module.exports = __webpack_public_path__ + "img/sport-51-@3x.0af225a9.png";